import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Typography } from '@material-ui/core';
import { graphql } from 'gatsby';
import Parser from 'html-react-parser';
import moment from 'moment';
import Layout from '../../components/layout';
import Hero from '../../components/Hero/Hero';
import LatestBlogPosts from '../../components/LatestBlogPosts/LatestBlogPosts';
import SEO from '../../components/seo';
import mapToComponent from '../../utils/mapToComponent';

export const query = graphql`
  query($slug: String!) {
    allWordpressWpBlogs(filter: { slug: { eq: $slug } }) {
      edges {
        node {
          title
          content
          date
          acf {
            author
            hero_image {
              source_url
            }
          }
        }
      }
    }
  }
`;

const useStyles = makeStyles((theme) => ({
  container: {
    margin: '20px 20px 90px',
    [theme.breakpoints.up('lg')]: {
      marginLeft: '200px',
      marginRight: '500px',
    },
  },
  heading: {
    paddingTop: '1.2rem',
    color: '#1E2731',
    fontFamily: 'Open Sans',
    fontWeight: 'bold',
    fontSize: '36px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '32px',
    },
  },
  content: {
    marginBottom: '50px',
    marginTop: '50px',
  },
  subHeading: {
    fontSize: 18,
    color: theme.palette.coreWaterBlue,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
  link: {
    color: theme.palette.coreRed,
  },
}));

const BlogPostPage = ({ data }) => {
  const classes = useStyles();
  const page = data.allWordpressWpBlogs.edges[0].node;
  const content = Parser(page.content, {
    replace: (domNode) => mapToComponent(domNode),
  });

  return (
    <Layout>
      <SEO title={page.title} />
      {page.acf.hero_image && <Hero src={page.acf.hero_image.source_url} />}
      <div className={classes.container}>
        <Typography variant="h1" className={classes.heading}>
          <strong>{page.title}</strong>
        </Typography>
        <div className={classes.subHeading}>
          {page.date
            ? `${moment(page.date, 'YYYY-MM-DDTHH:mm:ss. sssZ').format(
                'DD MMMM YYYY',
              )} - `
            : ''}
          {'by '}
          {page.acf.author}
        </div>
        {page.content && <div className={classes.content}>{content}</div>}
        <hr />
      </div>
      <LatestBlogPosts />
    </Layout>
  );
};

BlogPostPage.propTypes = {
  data: PropTypes.shape({
    allWordpressWpBlogs: PropTypes.shape({
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            title: PropTypes.string.isRequired,
            content: PropTypes.string.isRequired,
            date: PropTypes.string.isRequired,
            acf: PropTypes.shape({
              author: PropTypes.string.isRequired,
              tags: PropTypes.string,
              hero_image: PropTypes.shape({
                source_url: PropTypes.string,
              }),
            }),
          }),
        }),
      ),
    }),
  }).isRequired,
};

export default BlogPostPage;
